<template>
	<div>
		<a
			href="#"
			class="underline"
			@click="openMapPreview">
			{{ linkTitle }}
		</a>
		<ProductPreviewMap
			:title="title"
			:image-src="imageSrc"
			ref="mapPreviewRef" />
	</div>
</template>

<script setup>
	defineProps({
		linkTitle: {
			type: String,
			required: true,
		},
		title: {
			type: String,
			required: true,
		},
		imageSrc: {
			type: String,
			required: true,
		},
	})

	const mapPreviewRef = ref(null)
	const openMapPreview = () => {
		mapPreviewRef.value?.openModal()
	}
</script>

<style scoped></style>
